<template>
<br>
<h2>NotFound</h2>
</template>

<script setup>

</script>

<style scoped>

</style>